import { getRetailerOrder } from './api/retailers';
import { alertError } from './alert';
import { RETAILER_ORDERS_OPEN } from '../constants/retailerOrders';

export const retailerOrderOpen = (order) => ({ type: RETAILER_ORDERS_OPEN, payload: order });

export const retailerGetOrder = (order) => async (dispatch, getState) => {
  try {
    if (!order) {
      return dispatch(retailerOrderOpen(false));
    }

    const { retailerId } = getState().role;

    const response = await getRetailerOrder(retailerId, order.id);
    const orderInfo = response.data;

    if (orderInfo) {
      order.info = orderInfo;

      dispatch(retailerOrderOpen(order));
    }
  } catch (error) {
    dispatch(alertError(error));
  }
};
